import React from 'react';
import { Card, CardProps } from 'react-bootstrap';

import cx from 'classnames';

import { IFileProperties } from 'models/fileProperties';

import s from './GalleryTile.module.scss';

export interface GalleryTileProps extends CardProps {
  image: IFileProperties;
  imageAlt?: string;
  style?: any;
  className?: string;
}
const GalleryTile: React.FC<GalleryTileProps> = ({
  image,
  imageAlt,
  className,
  children,
  ...props
}) => {
  return (
    <Card
      className={cx(s['gallery-tile'], 'overflow-hidden', className)}
      {...props}
    >
      <Card.Body className={s['gallery-tile-wrapper']}>
        {!!image && (
          <div className={s.back}>
            {image && (
              <img
                loading="lazy"
                className="w-100"
                src={image.url}
                alt={imageAlt}
              />
            )}
          </div>
        )}
        <div className={s.top}>{children}</div>
      </Card.Body>
    </Card>
  );
};

export default GalleryTile;
